import styled from 'styled-components';
import { Text } from '../texts';
import {
  RECTANGLE_BORDER_COLORS,
  RECTANGLE_BUTTON_SIZING,
  BUTTON_FILL_COLORS,
} from './constants';

export const RectangleButtonStyle = styled.button<any>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: ${props => (props.mood === 'disabled' ? 'none' : 'auto')};
  width: ${props =>
    props.width
      ? props.width
      : props.size
        ? RECTANGLE_BUTTON_SIZING[props.size].width
        : RECTANGLE_BUTTON_SIZING.m.width}px;
  height: ${props =>
    props.height
      ? props.height
      : props.size
        ? RECTANGLE_BUTTON_SIZING[props.size].height
        : RECTANGLE_BUTTON_SIZING.m.height}px;
  border-radius: ${props =>
    props.borderRadius
      ? props.borderRadius
      : props.height
        ? props.height / 2
        : props.size
          ? RECTANGLE_BUTTON_SIZING[props.size].height / 2
          : RECTANGLE_BUTTON_SIZING.m.height / 2}px;
  border: ${props =>
    props.borderColor || props.ghost
      ? `${props.borderWidth ? props.borderWidth : 1}px solid ${props.borderColor
        ? props.theme.color[props.borderColor]
        : props.ghost
          ? !props.mood
            ? props.theme.color.disabled
            : props.theme.color[RECTANGLE_BORDER_COLORS[props.mood]]
          : props.theme.color.backgroundRush
      }`
      : 'none'};
  background-color: ${props =>
    props.backgroundColor
      ? props.theme.color[props.backgroundColor]
      : props.ghost || !props.mood
        ? props.theme.color.backgroundRush
        : props.theme.color[BUTTON_FILL_COLORS[props.mood]]};
  box-shadow: ${props => props.theme.shadow.s};
  transition: all ${p => p.theme.duration.s} ${p => p.theme.function.oq};

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${props => props.theme.shadow.m};
    background-color: ${props =>
    props.ghost
      ? props.borderColor
        ? props.theme.color[props.borderColor]
        : props.theme.color[RECTANGLE_BORDER_COLORS[props.mood]]
      : 'none'};
    svg {
      fill: ${props =>
    props.textHoverColor
      ? props.theme.color[props.textHoverColor]
      : props.ghost
        ? props.theme.color.white
        : !props.mood
          ? props.theme.color.turquoise
          : ''};
    }
    ${Text} {
      color: ${props =>
    props.textHoverColor
      ? props.theme.color[props.textHoverColor]
      : props.ghost && props.mood !== 'default'
        ? props.theme.color.white
        : props.mood === 'default'
          ? props.theme.color.mainFont
          : !props.mood
            ? props.theme.color.turquoise
            : ''};
    }
  }

  &:active {
    box-shadow: ${props => props.theme.shadow.m};
    transform: scale(0.95) translateY(2px);
  }
`;

export const RectangleButtonStyleWithIcon = styled(RectangleButtonStyle)`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  svg {
    height: ${props => props.iconHeight || 20}px;
    margin: 0 ${props => (props.rightIcon ? 0 : 10)}px 0
      ${props => (props.rightIcon ? 10 : 0)}px;
    fill: ${props =>
    props.theme.color[props.colorText] || props.theme.color.gray};
  }
`;
